import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { createSignalPayload, signalsPayload } from './types';

const initialState: createSignalPayload = {};

const componentSignalsSlice = createSlice({
  name: 'componentSignals',
  initialState,
  reducers: {
    sendSignalsAction: (state, action: PayloadAction<createSignalPayload>) => {
      for (const id in action.payload) {
        const signals = action.payload[id];
        if (!state[id]) {
          state[id] = signals;
        } else {
          Object.assign(state[id], signals);
        }
      }
    },
    toggleSignalsAction: (state, action: PayloadAction<signalsPayload>) => {
      for (const id in action.payload) {
        if (!state[id]) {
          continue;
        }
        for (const key of action.payload[id]) {
          if (
            state[id][key] === undefined ||
            typeof state[id][key] === 'boolean'
          ) {
            state[id][key] = !state[id][key];
          }
        }
      }
    },
    cleanSignalsAction: (state, action: PayloadAction<signalsPayload>) => {
      for (const id in action.payload) {
        if (!state[id]) {
          continue;
        }
        for (const key of action.payload[id]) {
          delete state[id][key];
        }
      }
    },
  },
});

export const { sendSignalsAction, toggleSignalsAction, cleanSignalsAction } =
  componentSignalsSlice.actions;
export const componentSignalsReducer = componentSignalsSlice.reducer;

export default componentSignalsSlice;
